module.exports = __webpack_public_path__ + "static/media/photo42.17e45ea9.jpg";